import type { T_Maybe } from '@tryiris-ai/js-types';
import { toString } from '@tryiris-ai/js-types';

/**
 * Normalize a preference key.
 *
 * @param key - Preference key.
 * @returns Normalized preference key.
 */
export const normalizeKey = (key: string): T_Maybe<string> => toString(key)?.toLowerCase();
